export interface Route {
  path: string;
  exact: boolean;
}

function matchRoute(currentPath: string, { path, exact }: Route) {
  if (exact) {
    return currentPath === path;
  }

  return currentPath.includes(path);
}

export function matchRoutes(currentPath: string, routes: Route[]) {
  return routes.some((route) => matchRoute(currentPath, route));
}
